import { render, staticRenderFns } from "./SfContentPage.vue?vue&type=template&id=7cd7692e&"
import script from "./SfContentPage.vue?vue&type=script&lang=js&"
export * from "./SfContentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports